import { Cancel, CheckCircle, Download } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { ColorsConstants } from "../cssUtils/constants";
import ButtonOne from "../common/normal-button";

const ExportButton = ({
  handleExport,
  text = "Export Data",
  icon = <Download />,
  state = "default",
  setState = null,
}) => {
  useEffect(() => {
    if (state && setState && (state === "success" || state === "failed")) {
      setTimeout(() => {
        setState("default");
      }, 3000);
    }
  }, [state, setState]);

  const _handleExport = () => {
    if (state === "default") {
      handleExport();
    }
  };

  return (
    <ButtonOne
      // variant="contained"
      disabled={state === "loading" || state === "success"}
      startIcon={
        state === "default" ? (
          icon
        ) : state === "loading" ? (
          <CircularProgress size={20} />
        ) : state === "success" ? (
          <CheckCircle color="success" />
        ) : (
          <Cancel color="error" />
        )
      }
      onClick={_handleExport}
      sx={{
        borderRadius: "8px",
        height: "40px",
        transition: "all 0.3s ease",
        width: "100%",
        textTransform: "capitalize",
        color: "white",
        backgroundColor: ColorsConstants.primaryPurple110,

        "&:hover": {
          backgroundColor: ColorsConstants.primaryPurple110,
        },

        ...(state === "success" && {
          borderColor: "success.main",
        }),

        ...(state === "failed" && {
          borderColor: "error.main",
        }),
      }}
    >
      {state === "default"
        ? text
        : state === "loading"
        ? "Exporting..."
        : state === "success"
        ? "Exported"
        : "Export Failed"}
    </ButtonOne>
  );
};

export default ExportButton;
